import { State } from 'src/redux';

export const getStripeSettings = (state: State) => state.integrations.stripe;

export const getMailchimpSettings = (state: State) => state.integrations.mailchimp;

export const getCloudflareSettings = (state: State) => state.integrations.cloudflare;

export const getRenteonSettings = (state: State) => state.integrations.renteon;
